import React, { useState } from 'react';
import { Settings as SettingsIcon, Save, Server, Sliders, Check } from 'lucide-react';
import { Header } from '../components/Header.js';
import { EduCard } from '../components/EduCard.js';
import { EduButton } from '../components/EduButton.js';

export const Settings: React.FC = () => {
  const [jobLease, setJobLease] = useState(120);
  const [maxAttempts, setMaxAttempts] = useState(3);
  const [defaultResolution, setDefaultResolution] = useState('1280x720');
  const [fps, setFps] = useState(25);
  const [saved, setSaved] = useState(false);

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div>
      <Header
        title="Configurações do Sistema"
        subtitle="Parâmetros operacionais globais do motor de renderização e políticas de fila"
      />

      <div className="p-8 max-w-4xl mx-auto space-y-6">
        <EduCard title="Parâmetros do Motor FFmpeg & Piper">
          <form onSubmit={handleSave} className="space-y-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-semibold text-txt-primary mb-1">
                  Resolução Padrão de Saída
                </label>
                <select
                  value={defaultResolution}
                  onChange={(e) => setDefaultResolution(e.target.value)}
                  className="w-full px-3 py-2 text-sm bg-surface border border-bdr rounded-md text-txt-primary focus:outline-none focus:border-brand-primary"
                >
                  <option value="1280x720">HD 720p (1280 × 720 / 16:9 — Recomendado)</option>
                  <option value="1920x1080">Full HD 1080p (1920 × 1080 / 16:9)</option>
                </select>
              </div>

              <div>
                <label className="block text-xs font-semibold text-txt-primary mb-1">
                  Taxa de Quadros (FPS)
                </label>
                <input
                  type="number"
                  value={fps}
                  onChange={(e) => setFps(Number(e.target.value))}
                  className="w-full px-3 py-2 text-sm bg-surface border border-bdr rounded-md text-txt-primary focus:outline-none focus:border-brand-primary"
                />
              </div>

              <div>
                <label className="block text-xs font-semibold text-txt-primary mb-1">
                  Lease do Job (Segundos)
                </label>
                <input
                  type="number"
                  value={jobLease}
                  onChange={(e) => setJobLease(Number(e.target.value))}
                  className="w-full px-3 py-2 text-sm bg-surface border border-bdr rounded-md text-txt-primary focus:outline-none focus:border-brand-primary"
                />
                <span className="text-[11px] text-txt-muted mt-1 block">
                  Tempo máximo sem heartbeat antes que outro worker assuma a tarefa.
                </span>
              </div>

              <div>
                <label className="block text-xs font-semibold text-txt-primary mb-1">
                  Tentativas Máximas de Reprocessamento
                </label>
                <input
                  type="number"
                  value={maxAttempts}
                  onChange={(e) => setMaxAttempts(Number(e.target.value))}
                  className="w-full px-3 py-2 text-sm bg-surface border border-bdr rounded-md text-txt-primary focus:outline-none focus:border-brand-primary"
                />
                <span className="text-[11px] text-txt-muted mt-1 block">
                  Número de retentativas antes de declarar falha definitiva e liberar a franquia.
                </span>
              </div>
            </div>

            <div className="flex items-center justify-between pt-4 border-t border-bdr">
              {saved && (
                <span className="text-xs text-status-success font-medium flex items-center gap-1">
                  <Check size={14} /> Configurações salvas com sucesso!
                </span>
              )}
              <EduButton type="submit" variant="primary" size="sm" className="ml-auto" icon={<Save size={14} />}>
                Salvar Configurações
              </EduButton>
            </div>
          </form>
        </EduCard>
      </div>
    </div>
  );
};
